import { ApiService } from "./ApiService.js";
import { ServiceConsts } from "$/services/ServiceConsts";


export class EventService {
 
    static async getBaseUrl() {
        return `${ServiceConsts.API_URL}/events`;
    }

    static async trackEvent(eventName) {
        try {
            const baseUrl = await this.getBaseUrl();
            const url = `${baseUrl}`;
            const body = { name: eventName };
            const response = await ApiService.post(url, body);
            return response; 
        } catch (error) {
            console.error("Error sending event to Event API:", error);
            throw error; 
        }
    }
  
}
